export default __webpack_public_path__ + "locales/sr-Latn-RS/FormFillingTipsDialog.json?hash=f901c483d231ea74a8a219d95019d4ab";